import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import OnboardPage from "@/pages/OnboardPage";
import WhitepaperPage from "@/pages/WhitepaperPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
	return (
		<div className="App">
			<HelmetProvider>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Landing />} />
					<Route path="/apply" element={<OnboardPage />} />
									<Route path="/whitepaper" element={<WhitepaperPage />} />
									<Route path="/admin" element={<AdminPage />} />
									<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</BrowserRouter>
			</HelmetProvider>
			<Toaster
				theme="light"
				position="bottom-right"
				toastOptions={{
					style: {
						background: "#f4f0e8",
						color: "#0f0f0f",
						border: "1px solid rgba(15,15,15,0.15)",
						borderRadius: 12,
						fontFamily: "Manrope, sans-serif",
					},
				}}
			/>
		</div>
	);
}

export default App;
